// extracted by mini-css-extract-plugin
module.exports = {"actionWidget":"ActionWidget_actionWidget__2JaMh","actionWidget_icon":"ActionWidget_actionWidget_icon__1uHrj","actionWidget_name":"ActionWidget_actionWidget_name__3Vpln"};